export class ParsingUtil {
	public static parseId(productId?: string | number | null): number | null {
		if (productId == null) return null;
		if (typeof productId === 'number') {
			return productId;
		}
		try {
			const parsed = parseInt(productId);
			if (`${parsed}` === 'NaN') return null;
			return parsed;
		} catch (ex) {
			console.log(`Error parsing product id '${productId}', NaN`);
			return null;
		}
	}

	public static parseInt(int?: string | number | null): number {
		if (int == null) return 0;
		try {
			return parseInt(int?.toString());
		} catch (_) {}
		return 0;
	}
}
